import React, { useEffect, useState } from 'react'
import { getImages } from '../Const'

const CustomerTable = ({ leadAction, leadData, leadStage, allLeads, leadStatus, leadsLoading }) => {
    const [visibleData, setVisibleData] = useState([]);
    const [limit, setLimit] = useState(20);
    const [isLoading, setIsLoading] = useState(true);
    useEffect(() => {
        setIsLoading(true);

        // console.log("processing leads",leadData.length, limit, allLeads.length, leadStage);

        const timer = setTimeout(() => {
            if(!leadsLoading) addAssocLeads();
        }, 500);

        const processedLeads = leadData.slice(0, limit).map((v) => {
            v.assocLeads = [];
            return v;
        });

        setVisibleData(processedLeads);
        setIsLoading(false);

        // console.log(processedLeads);

        return () => {
            clearTimeout(timer);
        };
    }, [leadData.length, limit, allLeads.length, leadStage, leadsLoading]);

    //console.log(leadData.sort((a,b) => b.appraisal_date_obj - a.appraisal_date_obj));

    const addAssocLeads = () => {
        const processedLeads = leadData.slice(0, limit).map((v) => {
            v.assocLeads = leadStage === 'Completed' ?
                allLeads.filter((lead) => (lead.id !== v.id.toString())) //lead.appraisal > 0 && 
                    .filter((lead) => (
                        (v.email && lead.email && lead.email.toLowerCase().replace(/[^a-zA-Z0-9]/g, '') === v.email.toLowerCase().replace(/[^a-zA-Z0-9]/g, '')) ||
                        (v.phone && lead.phone && lead.phone.toLowerCase().replace(/[^a-zA-Z0-9]/g, '') === v.phone.toLowerCase().replace(/[^a-zA-Z0-9]/g, ''))
                    )) : [];
            return v;
        });

        setVisibleData(processedLeads);
    }

    useEffect(() => {
        const handleScroll = () => {
            const scrollPosition = window.innerHeight + window.scrollY;
            const bottomPosition = document.documentElement.offsetHeight;
            if (scrollPosition >= bottomPosition - 100) {
                setLimit(prev => (prev + 10 > leadData.length ? leadData.length : prev + 10));
            }
        };
        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, [leadData]);
    const [hoveredIndex, setHoveredIndex] = useState(null);
    if (isLoading) {
        return <div className='loading-cardrop-box'>
                    <img className='loading-cardrop-image' src={getImages('loading-cardrop.gif')} alt=''/>
                    <div className='xs-title text-center text-gray text-uppercase font-1em'>Appraisals Currently Loading...</div>
                </div>;
    }

    const activePage = window.location.pathname.includes('/store') ? "/store" : "/web";

    return (
        <>
            <div className='cqr-table'>
                <table className='w-100'>
                    <thead>
                        <tr>
                            <th>ID</th>
                            <th>Customer Name</th>
                            {leadStage === 'Completed' && <th>&nbsp;</th>}
                            <th>Vehicle Info</th>
                            <th>Location</th>
                            {leadStatus !== 'Bought' &&
                                (leadStage === 'Completed' ?
                                    <th className='text-center'>Created by / <br />Status</th>
                                    : <th className='text-center'>Created by</th>
                                )
                            }
                            {leadStatus !== 'Bought' &&
                                (leadStage === 'Completed' ?
                                    <th className='text-center'>COMPLETED / <br />EXPIRATION</th>
                                    : <th className='text-center'>CREATED ON</th>
                                )
                            }
                            {leadStatus === 'Bought' &&
                                <th className='text-center'>Status</th>
                            }
                            {leadStatus === 'Bought' &&
                                <th className='text-center'>Bought Date</th>
                            }
                            <th className='text-center'>Details</th>
                        </tr>
                    </thead>
                    {visibleData.length > 0 ? (
                        <tbody>
                            {visibleData.sort((a,b) => leadStage == "InProgress" || leadStage == "InQueue" ? b.created_at_obj - a.created_at_obj : b.appraisal_date_obj - a.appraisal_date_obj).map((item, index) => (
                                <tr key={index}>
                                    <td className='cursor-pointer' onClick={() => leadAction(item)}>
                                        {item.lead_id}</td>
                                    <td className='cursor-pointer' onClick={() => leadAction(item)}>
                                        {item.full_name}</td>
                                    {leadStage === 'Completed' && (item.assocLeads.length >= 1 ? (
                                        <td>
                                            <div
                                                className={`position-relative popover-block ${hoveredIndex === index ? 'hovered' : ''}`}
                                                onMouseEnter={() => setHoveredIndex(index)}
                                                onMouseLeave={() => setHoveredIndex(null)}
                                            >
                                                <span
                                                    className="icon-badge"
                                                    style={{
                                                        background: `url(${getImages(item.assocLeads.length > 1 ? 'icon-badge-gold.png' : 'icon-badge-silver.png')})`,
                                                        color: item.assocLeads.length > 1 ? '#333' : "#fff"
                                                    }}
                                                >
                                                    {item.assocLeads.length}
                                                </span>
                                                <div className='popover-badge-outer'>
                                                    <div className='popover-badge-box'>
                                                        <div className='d-flex align-items-center justify-content-between pp-header'>
                                                            <div className='xs-title pp-title text-uppercase'>Previous Appraisals</div>
                                                            <div>
                                                                <button className='pp-close-btn' type='button' onClick={() => setHoveredIndex(null)}>
                                                                    <img src={getImages('close-shape.png')} />
                                                                </button>
                                                            </div>
                                                        </div>
                                                        <div className='pp-table'>
                                                            <table className='w-100'>
                                                                <tbody>
                                                                    {item.assocLeads.map((lead, i) => (
                                                                        <tr key={i}>
                                                                            <td>{lead?.vehicle_name?.slice(0, 35)}</td>
                                                                            <td>{lead.expiration_str ? lead?.expiration_str : ""}</td>
                                                                            <td className='text-end'>
                                                                                <button onClick={() => window.open(`${activePage}?lead_id=${lead?.id}`, '_blank')} className='blue-btn sm-btn text-uppercase'>Open</button>
                                                                            </td>
                                                                        </tr>
                                                                    ))}
                                                                </tbody>
                                                            </table>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </td>
                                    ) : (<td></td>))}
                                    <td className='cursor-pointer text-dblue' onClick={() => leadAction(item)}>
                                        {item.vehicle_name}</td>
                                    <td className='cursor-pointer' onClick={() => leadAction(item)}>
                                        {item.location}</td>
                                    {leadStatus !== 'Bought' &&
                                        <td className='cursor-pointer text-center' onClick={() => leadAction(item)}>
                                            Office <br />
                                            {leadStage === 'Completed' && item.status}
                                        </td>
                                    }
                                    {/* 'text-orange' and 'text-red' class name for developer use */}
                                    {leadStatus !== 'Bought' &&
                                        <>{leadStage === 'Completed' ?
                                            <td className={`cursor-pointer text-center text-dblue 
                                                ${item.days_to_expire > 2 && item.days_to_expire <= 4 ? 'text-yellow' : ''} 
                                                ${item.days_to_expire > 0 && item.days_to_expire <= 2 ? 'text-orange' : ''} 
                                                ${item.days_to_expire <= 0 ? 'text-red' : ''}`}
                                                onClick={() => leadAction(item)}
                                            >
                                                {item.appraisal_date_str} <br />
                                                {item.expiration_str}
                                            </td> :
                                            <td className='cursor-pointer text-center text-dblue' onClick={() => leadAction(item)}>
                                                {item.created_at_str}
                                            </td>
                                        }</>
                                    }
                                    {leadStatus === 'Bought' &&
                                        <td className='text-center'>Bought</td>
                                    }
                                    {leadStatus === 'Bought' &&
                                        <td className='text-center'>{item.appraisal_date_str}</td>
                                    }
                                    <td className="cursor-pointer text-center" onClick={() => leadAction(item)}>
                                        <img src={getImages("search.png")} alt="Search" />
                                    </td>
                                </tr>
                            )
                            )}
                        </tbody>
                    ) : (
                        <tbody>
                            <tr>
                                <td className="text-center" colSpan={leadStage === 'Completed' ? "8" : '7'}>Total Items: 0</td>
                            </tr>
                        </tbody>
                    )}
                </table>
            </div>
        </>
    )
}

export default CustomerTable